import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/authService';

const ProtectedRoute = ({ children }) => {
    if (!AuthService.isUsableToken()) {
        return <Navigate to="/login" replace />;
    }

    // 토큰이 있으면 자식 컴포넌트 렌더링
    return children;
};

export default ProtectedRoute;
